import { Component, Input, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { NavigationItem } from '../nav/nav-item.model';


@Component({
  selector: 'np-header',
  standalone: true,
  imports: [],
  templateUrl: 'header.component.html',
})
export class HeaderComponent {
  @Input() sitename: string = '';
  @Input() menuItems: NavigationItem[] = [];
  @Input() welcomeMessage?: string;

  isSearchVisible = false;
  isMenuVisible = false;

  constructor(private eRef: ElementRef, private renderer: Renderer2) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInsideMenu = this.eRef.nativeElement.querySelector('#menu')?.contains(event.target);
    const clickedInsideToggleMenu = this.eRef.nativeElement.querySelector('#toggle-menu')?.contains(event.target);

    const clickedInsideSearch = this.eRef.nativeElement.querySelector('#search')?.contains(event.target);
    const clickedInsideToggleSearch = this.eRef.nativeElement.querySelector('#toggle-search')?.contains(event.target);

    if (!clickedInsideMenu && !clickedInsideToggleMenu && this.isMenuVisible) {
      this.isMenuVisible = false;
    }
    if (!clickedInsideSearch && !clickedInsideToggleSearch && this.isSearchVisible) {
      this.isSearchVisible = false;
    }
  }
  toggleSearchVisibility() {
    this.isSearchVisible = !this.isSearchVisible;
  }
  toggleMenuVisibility() {
    this.isMenuVisible = !this.isMenuVisible;
  }
}